import { SerializedMeter } from '@enmon/commons/lib/enmon';
import {
  SerializedManufacturer,
  SerializedMeterModel,
  CreateInventoryMeterOutputDto,
  InventoryMeterMountType,
  OutputTechnology,
} from '@enmon/commons/lib/tools';
import { UploadFile } from 'antd';
import { Moment } from 'moment';
import type { RegisterState, ReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { SetState } from 'zustand';
import { Commodity } from '@enmon/commons/lib/shared';

export interface NewValuesStepForm {
  newSerialNumber?: SerializedMeter['serial'];
  newRegisterStates?: RegisterState[];
  calibrated?: Moment;
  manufactured?: Moment;
  manufacturer?: SerializedManufacturer['id'];
  meterModel?: SerializedMeterModel['id'];
  outputs?: Array<CreateInventoryMeterOutputDto>;
  detailPhotos?: UploadFile[];
  protocolPhotos?: UploadFile[];
  meterMountType?: InventoryMeterMountType;
  meterMountTechnology?: OutputTechnology | null;
  commodity?: Commodity;
}

const INITIAL_STATE: NewValuesStepForm = {
  newSerialNumber: undefined,
  newRegisterStates: [],
  calibrated: undefined,
  manufactured: undefined,
  manufacturer: undefined,
  meterModel: undefined,
  outputs: [],
  detailPhotos: [],
  protocolPhotos: [],
  meterMountType: undefined,
  meterMountTechnology: undefined,
  commodity: undefined,
};

export interface NewValuesStepSlice extends NewValuesStepForm {
  setNewValuesStepValues: (values: NewValuesStepForm) => void;
  resetNewValuesStepSlice: (initValues?: Partial<NewValuesStepForm>) => void;
}

export const createNewValuesStepSlice = (set: SetState<ReplaceMeterStore>): NewValuesStepSlice => ({
  ...INITIAL_STATE,
  setNewValuesStepValues: (values: NewValuesStepForm) => set(values),
  resetNewValuesStepSlice: (initValues = {}) => set({ ...INITIAL_STATE, ...initValues }),
});
